export class SwitchCompanyModel {
  constructor(
    public SelectedMainContact: number = null
  ){}
}
